import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { ProfitSummary } from '../../../services/financeService';

interface ProfitStatsProps {
    summary: ProfitSummary | null;
}

export const ProfitStats: React.FC<ProfitStatsProps> = ({ summary }) => {
    return (
        <Row gutter={16} style={{ marginBottom: 24 }}>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="总销售额 (Revenue)"
                        value={summary?.total_revenue}
                        precision={2}
                        prefix="$"
                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="毛利润 (Gross Profit)"
                        value={summary?.total_profit}
                        precision={2}
                        valueStyle={{ color: (summary?.total_profit || 0) >= 0 ? '#3f8600' : '#cf1322' }}
                        prefix="$"
                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="平均利润率 (Margin)"
                        value={summary?.avg_profit_margin}
                        precision={1}
                        suffix="%"
                        valueStyle={{ color: (summary?.avg_profit_margin || 0) >= 15 ? '#3f8600' : '#cf1322' }}
                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="总销量 (Units)"
                        value={summary?.total_units}
                        prefix={<DollarOutlined />}
                    />
                </Card>
            </Col>
        </Row>
    );
};
